<template>
    <div id="bene-bank-transfer-bank-name-container">
        <f7-list form class="form-group" v-if="showFormSet.bankTransfer">
            <f7-list-input
                v-if         ="showFormInput.bankTransfer.bankName"
                :label       ="bankNameLabel"
                :placeholder ="bankNamePlaceholder"
                :value       ="bankName"

                disabled
                outline
                floating-label
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'bankName',
                'bankId',
                'bankTypeId',
                'bankNameLabel',
                'bankNamePlaceholder',
                'isbKashTx',
                'showPreloaderState',
                'isCreateBeneficiary'
            ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'setShowPreloaderState'
            ]),
        }
    }
</script>